[
  {
    "id": 1,
    "title": "ARE YOU THERE GOD? IT'S ME, MARGARET.",
    "score": "99%",
    "rank": "#1",
    "consensus": "Effervescent and refreshingly frank about the travails of puberty, this long-awaited adaptation does full justice to Judy Blume's seminal novel.",
    "synopsis": "For over fifty years, Judy Blume's classic and groundbreaking novel Are You There God? It's Me, Margaret. has impacted generations... [More]",
    "starring": "Rachel McAdams, Abby Ryder Fortson, Elle Graham, Benny Safdie",
    "directed_by": "Kelly Fremon Craig"
  },
  {
    "id": 2,
    "title": "HUESERA: THE BONE WOMAN",
    "score": "97%",
    "rank": "#2",
    "consensus": "A bone-chilling body horror, Huesera offers genre fans a twisted take on What to Expect When You're Expecting.",
    "synopsis": "Valeria's joy at becoming a first-time mother is quickly taken away when she's cursed by a sinister entity. As danger... [More]",
    "starring": "Natalia Solián, Alfonso Dosal, Mayra Batalla, Mercedes Hernández",
    "directed_by": "Michelle Garza Cervera"
  },
  {
    "id": 3,
    "title": "BLACKBERRY",
    "score": "98%",
    "rank": "#3",
    "consensus": "With intelligence as sharp as its humor, BlackBerry takes a terrifically entertaining look at the rise and fall of a generation-defining gadget.",
    "synopsis": "'BlackBerry' tells the story of Mike Lazaridis and Jim Balsillie, the two men that charted the course of the spectacular... [More]",
    "starring": "Jay Baruchel, Glenn Howerton, Matt Johnson, Rich Sommer",
    "directed_by": "Matt Johnson"
  },
  {
    "id": 4,
    "title": "RYE LANE",
    "score": "98%",
    "rank": "#4",
    "consensus": "Good news, rom-com fans: Anyone looking for a smart, funny, and heartwarming new addition to the canon can find it waiting on Rye Lane.",
    "synopsis": "Yas (Vivian Oparah) and Dom (David Jonsson), two twenty-somethings both reeling from bad break-ups, connect over the course of an... [More]",
    "starring": "David Jonsson, Vivian Oparah, Charlie Knight, Simon Manyonda",
    "directed_by": "Raine Allen Miller"
  },
  {
    "id": 5,
    "title": "JOYLAND",
    "score": "98%",
    "rank": "#5",
    "consensus": "With stunning honesty that's achingly bittersweet, Joyland tackles gender and sexual fluidity in a repressed patriarchal society with wisps of hopefulness.",
    "synopsis": "The Ranas--a happily patriarchal joint family--yearn for the birth of a baby boy to continue the family line. Their youngest... [More]",
    "starring": "Ali Junejo, Rasti Farooq, Alina Khan, Sarwat Gil.",
    "directed_by": "Nashit Raza"
  },
  {
      "id": 6,
      "title": "FULL TIME",
      "rating": "98%",
      "consensus": "Led by Laure Calamy's gripping performance, Full Time serves as a sobering reminder that just staying financially afloat can sometimes feel like a white-knuckle thriller.",
      "synopsis": "Single mother Julie (César award-winning actress Laure Calamy) works a grueling job as a head chambermaid in a five-star Parisian...",
      "starring": "Laure Calamy, Anne Suarez, Geneviève Mnich, Cyril Gueï",
      "directed_by": "Eric Gravel"
    },
    {
      "id": 7,
      "title": "RETURN TO SEOUL",
      "rating": "97%",
      "consensus": "Sensitively attuned to its protagonist's quest, Return to Seoul uses one woman's story to explore universal truths about the human condition.",
      "synopsis": "On an impulse to reconnect with her origins, Freddie, 25, returns to South Korea for the first time, where she...",
      "starring": "Oh Kwang-rok, Kim Sun-young, Yoann Zimmer, Louis-Do de Lencquesaing",
      "directed_by": "Davy Chou"
    },
    {
      "id": 8,
      "title": "PAST LIVES",
      "rating": "97%",
      "consensus": "A remarkable debut for writer-director Celine Song, Past Lives uses the bonds between its sensitively sketched central characters to support trenchant observations on the human condition.",
      "synopsis": "Nora and Hae Sung, two deeply connected childhood friends, are wrest apart after Nora's family emigrates from South Korea. Two...",
      "starring": "Greta Lee, Teo Yoo, John Magaro, Seung-ah Moon",
      "directed_by": "Celine Song"
    },
    {
      "id": 9,
      "title": "SPIDER-MAN: ACROSS THE SPIDER-VERSE",
      "rating": "96%",
      "consensus": "Just as visually dazzling and action-packed as its predecessor, Spider-Man: Across the Spider-Verse thrills from start to cliffhanger conclusion.",
      "synopsis": "Miles Morales returns for the next chapter of the Oscar®-winning Spider-Verse saga, an epic adventure that will transport Brooklyn's full-time...",
      "starring": "Shameik Moore, Hailee Steinfeld, Oscar Isaac, Jake Johnson",
      "directed_by": "Joaquim Dos Santos, Kemp Powers, Justin K. Thompson"
    },
    {
      "id": 10,
      "title": "SUZUME",
      "rating": "96%",
      "consensus": "Suzume sees director Makoto Shinkai falling just a bit short of the bar set by previous outings -- but when the results are this visually thrilling and emotionally impactful, it's hard to find much fault.",
      "synopsis": "17-year-old Suzume's journey begins in a quiet town in Kyushu when she encounters a young man who tells her, 'I'm looking for a door.' What Suzume finds is a single weathered door standing upright in the midst of ruins as though it was shielded from whatever catastrophe struck. Seemingly drawn by its power, Suzume reaches for the knob.... Doors begin to open one after another all across Japan, unleashing destruction upon any who are near. Suzume must close these portals to prevent further disaster. The stars. The sunset. The morning sky. Within that realm, it was as though all time had melted together in the sky--guided by these mysterious doors, Suzume's journey to close doors is about to begin.",
      "starring": "Nanoka Hara, Hokuto Matsumura, Eri Fukatsu, Hakuo Matsumoto II",
      "directed_by": "Makoto Shinkai"
    },
    {
      "id": 11,
      "title": "A THOUSAND AND ONE",
      "score": "96%",
      "consensus": "A tribute to parental devotion and a testament to Teyana Taylor's talent, A Thousand and One presents a heart-wrenching portrait of perseverance in the face of systemic inequity.",
      "synopsis": "A THOUSAND AND ONE follows unapologetic and free-spirited Inez (Teyana Taylor), who kidnaps six-year-old Terry from the foster care system.... [More]",
      "starring": "Teyana Taylor, Aaron Kingsley Adetola, Aven Courtney, Josiah Cross",
      "directed_by": "A.V. Rockwell"
    },
    {
      "id": 12,
      "title": "THE BLUE CAFTAN",
      "score": "96%",
      "consensus": "A love story shaped by some surprising contours, The Blue Caftan surveys the hidden heart with compassion and grace.",
      "synopsis": "Halim and Mina run a traditional caftan store in one of Morocco's oldest medinas. In order to keep up with... [More]",
      "starring": "Lubna Azabal, Saleh Bakri, Ayoub Messioui",
      "directed_by": "Maryam Touzani"
    },
    {
      "id": 13,
      "title": "R.M.N.",
      "score": "96%",
      "consensus": "R.M.N.'s spare, elegant approach lends a deceptively cool surface to its caustic take on cultural divisions.",
      "synopsis": "Award-winning director Cristian Mungiu's (4 Months, 3 Weeks, 2 Days) gripping portrait of ethnic and economic resentments tearing at the... [More]",
      "starring": "Marin Grigore, Judith State, Monica Bîrlădeanu, Orsolya Moldován",
      "directed_by": "Cristian Mungiu"
    },
    {
      "id": 14,
      "title": "YOU HURT MY FEELINGS",
      "score": "95%",
      "consensus": "Smart, funny, and above all entertaining, You Hurt My Feelings finds writer-director Nicole Holofcener as sharply perceptive as ever.",
      "synopsis": "From acclaimed filmmaker Nicole Holofcener comes a sharply observed comedy about a novelist whose long standing marriage is suddenly upended... [More]",
      "starring": "Julia Louis-Dreyfus, Tobias Menzies, Michaela Watkins, Arian Moayed",
      "directed_by": "Nicole Holofcener"
    },
    {
      "id": 15,
      "title": "BLUE JEAN",
      "score": "95%",
      "consensus": "Bridging times past with issues that are still current, Blue Jean resonates intellectually and emotionally thanks to thoughtful direction and authentic performances.",
      "synopsis": "England, 1988 -- Margaret Thatcher's Conservative government is about to pass a law stigmatizing gays and lesbians, forcing Jean, a... [More]",
      "starring": "Rosy McEwen, Kerrie Hayes, Lydia Page, Stacy Abalogun",
      "directed_by": "Georgia Oakley"
    },
    {
      "id": 16,
      "title": "BARBIE",
      "score": "-",
      "consensus": "-",
      "synopsis": "To live in Barbie Land is to be a perfect being in a perfect place. Unless you have a full-on existential crisis. Or you're a Ken.",
      "starring": "Margot Robbie, Ryan Gosling, America Ferrera, Kate McKinnon, Michael Cera",
      "directed_by": "Greta Gerwig"
    },
    {
      "id": 16,
      "title": "ATTACHMENT",
      "rating": "95%",
      "consensus": "A possession thriller that knows the devil's in the details, Attachment scares some fresh angles out of a well-worn horror subgenre.",
      "synopsis": "ATTACHMENT is a horror romance about Maja, a has-been actress in Denmark, who falls in love with Leah, a young,... [More]",
      "starring": "Sofie Gråbøl, Josephine Park, Ellie Kendrick, David Dencik",
      "directed_by": "Gabriel Bier Gislason"
    },
    {
      "id": 17,
      "title": "SAINT OMER",
      "rating": "94%",
      "consensus": "A gut-punching contemplation of a woman's immigrant experience, Saint Omer puts a mother on the stand and the audience in the jury box to find humanity in the inhumane.",
      "synopsis": "Saint-Omer court of law. Young novelist Rama attends the trial of Laurence Coly, a young woman accused of killing her... [More]",
      "starring": "Kayije Kagame, Guslagie Malanda, Valérie Dréville, Aurélia Petit",
      "directed_by": "Alice Diop"
    },
    {
      "id": 18,
      "title": "JOHN WICK: CHAPTER 4",
      "rating": "94%",
      "consensus": "John Wick: Chapter 4 piles on more of everything -- and suggests that when it comes to a well-dressed Keanu Reeves dispatching his enemies in lethally balletic style, there can never be too much.",
      "synopsis": "John Wick (Keanu Reeves) uncovers a path to defeating The High Table. But before he can earn his freedom, Wick... [More]",
      "starring": "Keanu Reeves, Donnie Yen, Bill Skarsgård, Laurence Fishburne",
      "directed_by": "Chad Stahelski"
    },
    {
      "id": 19,
      "title": "HOW TO BLOW UP A PIPELINE",
      "rating": "94%",
      "consensus": "An explosive adaptation of Andreas Malm's treatise, How to Blow Up a Pipeline delivers a high-stakes eco-thriller ignited by riveting and complex antiheroes.",
      "synopsis": "A crew of young environmental activists execute a daring mission to sabotage an oil pipeline, in Daniel Goldhaber's taut and... [More]",
      "starring": "Ariela Barer, Kristine Froseth, Lukas Gage, Forrest Goodluck",
      "directed_by": "Daniel Goldhaber"
    },
    {
      "id": 20,
      "title": "THE NIGHT OF THE 12TH",
      "rating": "94%",
      "consensus": "A grim, well-crafted thriller, The Night of the 12th takes a finely layered look at the toxic ripple effect of violence.",
      "synopsis": "In nearly every police precinct, detectives are inevitably confronted with a case that goes unsolved. The more heinous the crime,... [More]",
      "starring": "Bastien Bouillon, Bouli Lanners, Anouk Grinberg, Mouna Soualem",
      "directed_by": "Dominik Moll"
    },
    {
      "id": 21,
      "title": "AFTER LOVE",
      "rating": "94%",
      "consensus": "After Love marks an impressively nuanced feature debut for writer-director Aleem Khan -- and a brilliant showcase for Joanna Scanlan's dramatic chops.",
      "synopsis": "Set in the port town of Dover, Mary Hussain suddenly finds herself a widow following the unexpected death of her husband. A day after the burial, she discovers he has a secret just twenty-one miles across the English Channel in Calais.",
      "starring": "Joanna Scanlan, Nathalie Richards, Talid Ariss",
      "directed_by": "Aleem Khan"
    },
    {
      "id": 22,
      "title": "M3GAN",
      "rating": "93%",
      "consensus": "Unapologetically silly and all the more entertaining for it, M3GAN is the rare horror-comedy that delivers chuckles as effortlessly as chills.",
      "synopsis": "M3GAN is a marvel of artificial intelligence, a life-like doll programmed to be a child's greatest companion and a parent's... [More]",
      "starring": "Allison Williams, Violet McGraw, Ronny Chieng, Brian Jordan Alvarez",
      "directed_by": "Gerard Johnstone"
  },
  {
      "id": 23,
      "title": "INFLUENCER",
      "rating": "92%",
      "consensus": "Influencer should get plenty of likes from horror fans hungry for a smart, scary chiller with something to say.",
      "synopsis": "INFLUENCER tells the story of Madison (Emily Tennant, \"Riverdale\"), a popular social media influencer who is having a lonely and... [More]",
      "starring": "Emily Tennant, Cassandra Naud, Sara Canning, Rory J. Saper",
      "directed_by": "Kurtis David Harder"
  },
  {
      "id": 24,
      "title": "CHILE '76",
      "rating": "92%",
      "consensus": "Chile '76 is an intriguing historical noir that radiographs Pinochet's patronizing and patriarchal society through the eyes of a steely bourgeois woman who dares to take a stand.",
      "synopsis": "Chile, 1976. Carmen heads off to her beach house to supervise its renovation. Her husband, children, and grandchildren come back... [More]",
      "starring": "Aline Küppenheim, Nicolás Sepúlveda, Hugo Medina, Alejandro Goic",
      "directed_by": "Manuela Martelli"
  },
  {
    "id": 26,
    "title": "The Shawshank Redemption",
    "rating": "91%",
    "consensus": "With its poignant story and stellar performances, The Shawshank Redemption has become a modern classic and a beloved film for audiences around the world.",
    "synopsis": "Two imprisoned men bond over a number of years, finding solace and eventual redemption through acts of common decency.",
    "starring": "Tim Robbins, Morgan Freeman, Bob Gunton",
    "directed_by": "Frank Darabont"
  },
  {
    "id": 28,
    "title": "The Dark Knight",
    "rating": "94%",
    "consensus": "Led by an iconic performance by Heath Ledger as the Joker, The Dark Knight is a gripping and visually stunning superhero film that transcends the genre.",
    "synopsis": "When the Joker wreaks havoc on Gotham City, Batman must confront his own moral dilemmas as he fights to protect the city he has sworn to defend.",
    "starring": "Christian Bale, Heath Ledger, Aaron Eckhart",
    "directed_by": "Christopher Nolan"
  },
  {
    "id": 29,
    "title": "The Matrix",
    "rating": "87%",
    "consensus": "The Matrix is a groundbreaking sci-fi film that combines mind-bending concepts with thrilling action sequences, creating a visually stunning and thought-provoking experience.",
    "synopsis": "A computer hacker learns about the true nature of his reality and his role in the war against the machines.",
    "starring": "Keanu Reeves, Laurence Fishburne, Carrie-Anne Moss",
    "directed_by": "The Wachowskis"
  },
  {
    "id": 30,
    "title": "Star Wars: Episode IV - A New Hope",
    "rating": "93%",
    "consensus": "A New Hope is the film that launched the epic Star Wars saga, introducing audiences to a galaxy far, far away and capturing their imaginations with its unforgettable characters and timeless story.",
    "synopsis": "Luke Skywalker embarks on a journey to rescue Princess Leia from the clutches of the evil Darth Vader and help the Rebel Alliance in their struggle against the Galactic Empire.",
    "starring": "Mark Hamill, Harrison Ford, Carrie Fisher",
    "directed_by": "George Lucas"
  },
  {
    "id": 32,
    "title": "The Lord of the Rings: The Fellowship of the Ring",
    "rating": "91%",
    "consensus": "The Fellowship of the Ring is the captivating first installment of the Lord of the Rings trilogy, featuring breathtaking visuals, a richly detailed world, and an epic story of good versus evil.",
    "synopsis": "A young hobbit named Frodo Baggins embarks on a perilous journey to destroy a powerful ring and save Middle-earth from the dark lord Sauron.",
    "starring": "Elijah Wood, Ian McKellen, Viggo Mortensen",
    "directed_by": "Peter Jackson"
  },
  {
    "id": 33,
    "title": "Inception",
    "rating": "87%",
    "consensus": "Inception is a mind-bending and visually stunning film that takes audiences on a thrilling journey through dreams and reality, leaving them questioning what is real and what is illusion.",
    "synopsis": "A skilled thief, specializing in the extraction of valuable secrets from people's dreams, is given a seemingly impossible task of planting an idea in someone's mind.",
    "starring": "Leonardo DiCaprio, Joseph Gordon-Levitt, Ellen Page",
    "directed_by": "Christopher Nolan"
  },
  {
    "id": 34,
    "title": "In the Mood for Love",
    "rating": "87%",
    "consensus": "In the Mood for Love is a visually stunning and emotionally resonant film that explores themes of love, desire, and missed connections in 1960s Hong Kong.",
    "synopsis": "Two neighbors form a bond when they suspect their spouses are having an affair, leading them to confront their own feelings for each other.",
    "starring": "Tony Leung, Maggie Cheung, Rebecca Pan",
    "directed_by": "Wong Kar-wai"
  },
  {
    "id": 35,
    "title": "Shrek 2",
    "rating": "89%",
    "consensus": "Shrek 2 is a hilarious and heartwarming animated film that takes viewers on a fairy tale adventure filled with memorable characters and clever humor.",
    "synopsis": "Shrek and Fiona return from their honeymoon to find an invitation from Fiona's parents, leading them on a journey to meet the royal in-laws.",
    "starring": "Mike Myers, Eddie Murphy, Cameron Diaz",
    "directed_by": "Andrew Adamson, Kelly Asbury, Conrad Vernon"
  },
  {
    "id": 36,
    "title": "ASTEROID CITY",
    "rating": "Not Available",
    "consensus": "Asteroid City is unlikely to win Wes Anderson many new converts, but those who respond to his signature style will find this a return to immaculately arranged form.",
    "synopsis": "The itinerary of a Junior Stargazer/Space Cadet convention (organized to bring together students and parents from across the country for fellowship and scholarly competition) is spectacularly disrupted by world-changing events.",
    "starring": "Jason Schwartzman, Scarlett Johansson, Tom Hanks, Jeffrey Wright",
    "directed_by": "Wes Anderson"
  },
  {
    "id": 38,
    "title": "Pride and Prejudice",
    "rating": "85%",
    "consensus": "Pride and Prejudice is a timeless romantic drama that brings Jane Austen's classic novel to life, featuring strong performances and beautiful cinematography.",
    "synopsis": "In 19th-century England, the headstrong Elizabeth Bennet clashes with the arrogant Mr. Darcy, leading to a captivating and complex love story.",
    "starring": "Keira Knightley, Matthew Macfadyen, Rosamund Pike",
    "directed_by": "Joe Wright"
  },
  {
    "id": 39,
    "title": "Scream",
    "rating": "79%",
    "consensus": "Scream revitalized the slasher genre with its self-awareness and clever meta-commentary, delivering a thrilling and entertaining experience for horror fans.",
    "synopsis": "A masked killer terrorizes a small town, targeting a group of high school students, who must uncover the killer's identity before it's too late.",
    "starring": "Neve Campbell, Courteney Cox, David Arquette",
    "directed_by": "Wes Craven"
  },
  {
    "id": 40,
    "title": "Scream 2",
    "rating": "81%",
    "consensus": "Scream 2 successfully builds upon its predecessor with a fresh set of twists and turns, offering more suspense, scares, and self-aware humor.",
    "synopsis": "A new string of murders reminiscent of the Ghostface killer's reign of terror haunts a college campus, forcing the survivors of the first attack to confront their past fears.",
    "starring": "Neve Campbell, Courteney Cox, David Arquette",
    "directed_by": "Wes Craven"
  },
  {
    "id": 41,
    "title": "Scream 6",
    "rating": "Not Available",
    "consensus": "Scream 6 continues the iconic horror franchise with a new chapter of suspense, mystery, and self-referential humor, keeping audiences on the edge of their seats.",
    "synopsis": "When a new wave of killings begins in the town of Woodsboro, a new generation must face the return of Ghostface and uncover the dark secrets behind the mask.",
    "starring": "TBD",
    "directed_by": "TBD"
  },
  {
    "id": 42,
    "title": "Spirited Away",
    "rating": "97%",
    "consensus": "Spirited Away is a magical and enchanting animated film that transports viewers to a fantastical world filled with imaginative creatures and a heartfelt coming-of-age story.",
    "synopsis": "A young girl named Chihiro stumbles upon a mysterious spirit world, where she must navigate through various challenges to rescue her parents and find her way back home.",
    "starring": "Rumi Hiiragi, Miyu Irino, Mari Natsuki",
    "directed_by": "Hayao Miyazaki"
  },
  {
    "id": 43,
    "title": "Sunset Boulevard",
    "rating": "98%",
    "consensus": "Sunset Boulevard is a classic film noir that masterfully explores themes of faded glory, obsession, and the dark side of Hollywood, anchored by a mesmerizing performance by Gloria Swanson.",
    "synopsis": "A struggling screenwriter becomes entangled with a faded silent film star, leading to a twisted and haunting tale of delusion and desperation.",
    "starring": "William Holden, Gloria Swanson, Erich von Stroheim",
    "directed_by": "Billy Wilder"
  },
  {
    "id": 44,
    "title": "Casablanca",
    "rating": "97%",
    "consensus": "Casablanca is a timeless romantic drama that has endured as a cinematic masterpiece, featuring memorable performances, quotable dialogue, and a captivating wartime love story.",
    "synopsis": "Set in World War II-era Casablanca, an American expatriate must choose between love and virtue when his former lover and her husband seek his help to escape the Nazis.",
    "starring": "Humphrey Bogart, Ingrid Bergman, Paul Henreid",
    "directed_by": "Michael Curtiz"
  },
  {
    "id": 45,
    "title": "Whiplash",
    "rating": "94%",
    "consensus": "Whiplash is an intense and gripping drama that explores the pursuit of greatness and the sacrifices required to achieve it, fueled by electrifying performances and a pulsating soundtrack.",
    "synopsis": "A young drummer enrolls in a prestigious music conservatory, where he comes under the brutal tutelage of an esteemed but demanding instructor.",
    "starring": "Miles Teller, J.K. Simmons, Paul Reiser",
    "directed_by": "Damien Chazelle"
  },
  {
    "id": 46,
    "title": "Barry Lyndon",
    "rating": "94%",
    "consensus": "Barry Lyndon is a visually stunning period drama that showcases Stanley Kubrick's meticulous attention to detail, featuring breathtaking cinematography and a compelling narrative.",
    "synopsis": "An Irish rogue named Barry Lyndon navigates through 18th-century Europe, using his wit and cunning to rise in the ranks of society.",
    "starring": "Ryan O'Neal, Marisa Berenson, Patrick Magee",
    "directed_by": "Stanley Kubrick"
  },
  {
    "id": 47,
    "title": "Twilight",
    "rating": "49%",
    "consensus": "Twilight is a supernatural romance that captivated a generation of fans with its star-crossed love story, but received mixed reviews for its pacing and character development.",
    "synopsis": "A teenage girl falls in love with a mysterious vampire, leading to a dangerous and forbidden romance that puts her life at risk.",
    "starring": "Kristen Stewart, Robert Pattinson, Taylor Lautner",
    "directed_by": "Catherine Hardwicke"
  },
  {
    "id": 48,
    "title": "The Hunger Games",
    "rating": "84%",
    "consensus": "The Hunger Games is a thrilling dystopian adventure that resonated with audiences for its engaging story, strong performances, and social commentary.",
    "synopsis": "In a post-apocalyptic world, a young girl volunteers for a brutal televised competition where teenagers fight to the death, challenging the oppressive regime that controls their lives.",
    "starring": "Jennifer Lawrence, Josh Hutcherson, Liam Hemsworth",
    "directed_by": "Gary Ross"
  },
  {
    "id": 49,
    "title": "Harry Potter and the Philosopher's Stone",
    "rating": "81%",
    "consensus": "Harry Potter and the Philosopher's Stone introduces audiences to the magical world of Hogwarts with its enchanting story, charming characters, and visual spectacle.",
    "synopsis": "An orphaned boy named Harry Potter discovers he is a wizard and enrolls in Hogwarts School of Witchcraft and Wizardry, where he unravels the mysteries of his past and confronts the dark forces threatening the wizarding world.",
    "starring": "Daniel Radcliffe, Rupert Grint, Emma Watson",
    "directed_by": "Chris Columbus"
  },
  {
    "id": 50,
    "title": "The Lion King",
    "rating": "93%",
    "consensus": "The Lion King is a beloved animated classic that combines stunning visuals, memorable songs, and a heartwarming story to create a timeless masterpiece.",
    "synopsis": "A young lion prince named Simba must reclaim his throne from his treacherous uncle and fulfill his destiny as the rightful king of the Pride Lands.",
    "starring": "Matthew Broderick, Jeremy Irons, James Earl Jones",
    "directed_by": "Roger Allers, Rob Minkoff"
  },
  {
    "id": 51,
    "title": "The Wizard of Oz",
    "rating": "98%",
    "consensus": "The Wizard of Oz is a magical and enchanting fantasy adventure that has captivated audiences for generations with its iconic characters, memorable songs, and timeless message.",
    "synopsis": "Dorothy, a young girl from Kansas, is swept away to the magical land of Oz, where she embarks on a journey to find the powerful Wizard and return home.",
    "starring": "Judy Garland, Frank Morgan, Ray Bolger",
    "directed_by": "Victor Fleming"
  },
  {
    "id": 52,
    "title": "Breakfast at Tiffany's",
    "rating": "87%",
    "consensus": "Breakfast at Tiffany's is a stylish romantic comedy that showcases Audrey Hepburn's iconic performance, timeless fashion, and a bittersweet story of love and self-discovery.",
    "synopsis": "A young woman in New York City, known for her eccentricities and love for expensive things, forms an unlikely bond with a struggling writer in her apartment building.",
    "starring": "Audrey Hepburn, George Peppard, Patricia Neal",
    "directed_by": "Blake Edwards"
  },
  {
    "id": 53,
    "title": "Citizen Kane",
    "rating": "100%",
    "consensus": "Citizen Kane is a groundbreaking masterpiece of cinema that revolutionized storytelling techniques, featuring Orson Welles' tour-de-force performance and a captivating examination of power and identity.",
    "synopsis": "A newspaper tycoon's life is examined through the eyes of those who knew him, as a reporter investigates the meaning behind his dying words: 'Rosebud'.",
    "starring": "Orson Welles, Joseph Cotten, Dorothy Comingore",
    "directed_by": "Orson Welles"
  },
  {
    "id": 54,
    "title": "The Sound of Music",
    "rating": "91%",
    "consensus": "The Sound of Music is a joyous and heartwarming musical that showcases memorable songs, stunning landscapes, and Julie Andrews' radiant performance as Maria.",
    "synopsis": "A young woman named Maria becomes a governess for a widowed naval captain's seven children, bringing joy and music back into their lives amidst the rising tensions of World War II.",
    "starring": "Julie Andrews, Christopher Plummer, Eleanor Parker",
    "directed_by": "Robert Wise"
  },
  {
    "id": 55,
    "title": "12 Angry Men",
    "rating": "100%",
    "consensus": "12 Angry Men is a gripping and thought-provoking courtroom drama that delves into themes of justice, prejudice, and the power of reasonable doubt, driven by stellar performances and powerful storytelling.",
    "synopsis": "In a jury room, one juror's doubts about a murder case gradually expose the flaws and biases of the legal system as the rest of the jurors reconsider their initial verdict.",
    "starring": "Henry Fonda, Lee J. Cobb, Martin Balsam",
    "directed_by": "Sidney Lumet"
  },
  {
    "id": 56,
    "title": "Singin' in the Rain",
    "rating": "100%",
    "consensus": "Singin' in the Rain is a joyful and exuberant musical that showcases dazzling dance numbers, catchy songs, and a lighthearted story set during Hollywood's transition from silent films to talkies.",
    "synopsis": "A silent film star and a young dancer navigate the challenges and romance of the film industry as talking pictures take over, leading to memorable musical sequences and comedic moments.",
    "starring": "Gene Kelly, Donald O'Connor, Debbie Reynolds",
    "directed_by": "Gene Kelly, Stanley Donen"
  },
  {
    "id": 57,
    "title": "Rebecca",
    "rating": "100%",
    "consensus": "Rebecca is a haunting and atmospheric psychological thriller that captivates with its suspenseful storytelling, lush cinematography, and memorable performances.",
    "synopsis": "A young woman marries a wealthy widower, only to find herself haunted by the memory of his deceased first wife, Rebecca.",
    "starring": "Laurence Olivier, Joan Fontaine, Judith Anderson",
    "directed_by": "Alfred Hitchcock"
  },
  {
    "id": 58,
    "title": "Vertigo",
    "rating": "93%",
    "consensus": "Vertigo is a mesmerizing and psychologically complex thriller that explores themes of obsession, identity, and manipulation, crafted with Hitchcock's signature visual style and masterful storytelling.",
    "synopsis": "A retired detective suffering from acrophobia becomes entangled in a mysterious and obsessive love affair, leading to a series of twists and revelations.",
    "starring": "James Stewart, Kim Novak, Barbara Bel Geddes",
    "directed_by": "Alfred Hitchcock"
  },
  {
    "id": 59,
    "title": "The Philadelphia Story",
    "rating": "97%",
    "consensus": "The Philadelphia Story is a sophisticated and witty romantic comedy that showcases sparkling dialogue, sharp performances, and a delightful love triangle.",
    "synopsis": "As her wedding day approaches, a wealthy socialite finds herself caught between her charming ex-husband and a tabloid reporter assigned to cover the event.",
    "starring": "Katharine Hepburn, Cary Grant, James Stewart",
    "directed_by": "George Cukor"
  },
  {
    "id": 60,
    "title": "Indiana Jones and the Raiders of the Lost Ark",
    "rating": "95%",
    "consensus": "Indiana Jones and the Raiders of the Lost Ark is a thrilling and adventurous tale that combines action, humor, and archaeology, introducing audiences to one of cinema's most iconic heroes.",
    "synopsis": "Renowned archaeologist Indiana Jones races against the Nazis in a quest to find the mythical Ark of the Covenant, a powerful relic with the potential to change the course of history.",
    "starring": "Harrison Ford, Karen Allen, Paul Freeman",
    "directed_by": "Steven Spielberg"
  },
  {
    "id": 61,
    "title": "AVATAR THE WAY OF WATER",
    "rating": "76%",
    "consensus": "Narratively, it might be fairly standard stuff -- but visually speaking, Avatar: The Way of Water is a stunningly immersive experience",
    "synopsis": "Set more than a decade after the events of the first film, 'Avatar: The Way of Water' begins to tell the story of the Sully family (Jake, Neytiri, and their kids), the trouble that follows them, the lengths they go to keep each other safe, the battles they fight to stay alive, and the tragedies they endure.",
    "starring": "Joanna Scanlan, Nathalie Richards, Talid Ariss",
    "directed_by": "Aleem Khan"
  }
]
